import { lazy } from 'react'

import { Card } from '@procurify/ui'
import { Redirect } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { useRequestedExportsPageGuard } from './hooks/useRequestedExportsPageGuard'
import messages from './messages'
import { type ExportDataPageLocationState } from './types'

const RequestedExportsViewChunk = lazy(() =>
  import('../feature-sets/RequestedExportsView').then(
    ({ RequestedExportsView }) => ({
      default: RequestedExportsView,
    })
  )
)

export const RequestedExportsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const { isAllowed, exportConfig, typeLabel } = useRequestedExportsPageGuard()

  // Unknown type or failed permission/switch gate (BHV-036) — the landing
  // page consumes the accessDenied state and fires the warning toast (it
  // cannot fire here: on hard loads the ToastContainer has not subscribed
  // yet and the toast would be silently dropped)
  if (!isAllowed || !exportConfig || !typeLabel) {
    return (
      <Redirect
        to={{
          pathname: url('ExportDataPage'),
          state: { accessDenied: true } as ExportDataPageLocationState,
        }}
      />
    )
  }

  return (
    <Page
      pageTitle={intl.formatMessage(messages.requestedExportsTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('ExportDataPage'),
          name: intl.formatMessage(messages.exportDataTitle),
        },
        {
          name: intl.formatMessage(typeLabel),
        },
      ]}
    >
      <Card>
        <Card.Content>
          <RequestedExportsViewChunk exportConfig={exportConfig} />
        </Card.Content>
      </Card>
    </Page>
  )
}
